/**
 * @generated SignedSource<<fd0d41464314b2928cb6d547e9e00bae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordCompanyVideoButton_Firm$data = {
  readonly rawId: number | null | undefined;
  readonly self: boolean | null | undefined;
  readonly video: {
    readonly rawId: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RecordCompanyVideoButton_Firm";
};
export type RecordCompanyVideoButton_Firm$key = {
  readonly " $data"?: RecordCompanyVideoButton_Firm$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordCompanyVideoButton_Firm">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordCompanyVideoButton_Firm",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Video",
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Firm",
  "abstractKey": null
};
})();

(node as any).hash = "f340d853735fbabc390c594286c53437";

export default node;
